<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8514_64485)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="#C2C2C6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint0_linear_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint1_linear_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint2_linear_8514_64485)"
        fill-opacity="0.39"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint3_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint4_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint5_radial_8514_64485)"
        fill-opacity="0.3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint6_radial_8514_64485)"
        fill-opacity="0.3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint7_radial_8514_64485)"
        fill-opacity="0.3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint8_radial_8514_64485)"
        fill-opacity="0.3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54688 8.53906C7.54688 5.00962 10.4081 2.14844 13.9375 2.14844C17.4669 2.14844 20.3281 5.00962 20.3281 8.53906V14.1016H17.5781V8.53906C17.5781 6.5284 15.9482 4.89844 13.9375 4.89844C11.9268 4.89844 10.2969 6.5284 10.2969 8.53906V14.1016H7.54688V8.53906Z"
        fill="url(#paint9_radial_8514_64485)"
        fill-opacity="0.3"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint10_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint11_radial_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint12_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint13_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint14_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint15_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint16_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint17_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint18_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint19_radial_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint20_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint21_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint22_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint23_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint24_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint25_linear_8514_64485)"
      />
      <rect
        x="3"
        y="11.0859"
        width="21.9375"
        height="18.8438"
        rx="3"
        fill="url(#paint26_linear_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9551 17.623C13.6196 17.623 13.3477 17.895 13.3477 18.2305C13.3477 18.4452 13.4577 18.6358 13.634 18.7465L13.9595 18.9509L14.2826 18.7424C14.4553 18.631 14.5625 18.4426 14.5625 18.2305C14.5625 17.895 14.2906 17.623 13.9551 17.623ZM9.34766 18.2305C9.34766 15.6859 11.4104 13.623 13.9551 13.623C16.4997 13.623 18.5625 15.6859 18.5625 18.2305C18.5625 19.4234 18.1083 20.5096 17.3672 21.3262V23.7344C17.3672 25.6113 15.8457 27.1328 13.9688 27.1328C12.0918 27.1328 10.5703 25.6113 10.5703 23.7344V21.3561C9.81297 20.5361 9.34766 19.438 9.34766 18.2305Z"
        fill="url(#paint27_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9551 17.623C13.6196 17.623 13.3477 17.895 13.3477 18.2305C13.3477 18.4452 13.4577 18.6358 13.634 18.7465L13.9595 18.9509L14.2826 18.7424C14.4553 18.631 14.5625 18.4426 14.5625 18.2305C14.5625 17.895 14.2906 17.623 13.9551 17.623ZM9.34766 18.2305C9.34766 15.6859 11.4104 13.623 13.9551 13.623C16.4997 13.623 18.5625 15.6859 18.5625 18.2305C18.5625 19.4234 18.1083 20.5096 17.3672 21.3262V23.7344C17.3672 25.6113 15.8457 27.1328 13.9688 27.1328C12.0918 27.1328 10.5703 25.6113 10.5703 23.7344V21.3561C9.81297 20.5361 9.34766 19.438 9.34766 18.2305Z"
        fill="url(#paint28_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9551 17.623C13.6196 17.623 13.3477 17.895 13.3477 18.2305C13.3477 18.4452 13.4577 18.6358 13.634 18.7465L13.9595 18.9509L14.2826 18.7424C14.4553 18.631 14.5625 18.4426 14.5625 18.2305C14.5625 17.895 14.2906 17.623 13.9551 17.623ZM9.34766 18.2305C9.34766 15.6859 11.4104 13.623 13.9551 13.623C16.4997 13.623 18.5625 15.6859 18.5625 18.2305C18.5625 19.4234 18.1083 20.5096 17.3672 21.3262V23.7344C17.3672 25.6113 15.8457 27.1328 13.9688 27.1328C12.0918 27.1328 10.5703 25.6113 10.5703 23.7344V21.3561C9.81297 20.5361 9.34766 19.438 9.34766 18.2305Z"
        fill="url(#paint29_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9551 17.623C13.6196 17.623 13.3477 17.895 13.3477 18.2305C13.3477 18.4452 13.4577 18.6358 13.634 18.7465L13.9595 18.9509L14.2826 18.7424C14.4553 18.631 14.5625 18.4426 14.5625 18.2305C14.5625 17.895 14.2906 17.623 13.9551 17.623ZM9.34766 18.2305C9.34766 15.6859 11.4104 13.623 13.9551 13.623C16.4997 13.623 18.5625 15.6859 18.5625 18.2305C18.5625 19.4234 18.1083 20.5096 17.3672 21.3262V23.7344C17.3672 25.6113 15.8457 27.1328 13.9688 27.1328C12.0918 27.1328 10.5703 25.6113 10.5703 23.7344V21.3561C9.81297 20.5361 9.34766 19.438 9.34766 18.2305Z"
        fill="url(#paint30_radial_8514_64485)"
      />
      <path
        d="M15.3672 20.4228C16.0864 19.9586 16.5625 19.1501 16.5625 18.2305C16.5625 16.7904 15.3951 15.623 13.9551 15.623C12.515 15.623 11.3477 16.7904 11.3477 18.2305C11.3477 19.1617 11.8359 19.979 12.5703 20.4402V23.7344C12.5703 24.5067 13.1964 25.1328 13.9688 25.1328C14.7411 25.1328 15.3672 24.5067 15.3672 23.7344V20.4228Z"
        fill="url(#paint31_radial_8514_64485)"
      />
      <path
        d="M18.4221 11.0859C18.3746 11.3522 18.2363 12.0933 18.2363 12.3732C18.2363 14.2977 19.4097 15.9481 21.0801 16.648V19.4895C21.0801 19.6971 21.1608 19.8966 21.3051 20.0457L21.7236 20.4784C21.8591 20.6184 21.9316 20.8074 21.9247 21.002C21.9191 21.1592 21.8619 21.3101 21.762 21.4316L21.5623 21.6742C21.4627 21.7953 21.4082 21.9473 21.4082 22.1041C21.4082 22.2581 21.4608 22.4074 21.5571 22.5275L21.7524 22.7709C21.8583 22.9029 21.916 23.067 21.916 23.2363C21.916 23.4432 21.8298 23.6407 21.6782 23.7814L21.336 24.0989C21.1728 24.2503 21.0801 24.4628 21.0801 24.6854V26.217C21.0801 27.2094 22.0274 29.6953 23.0198 29.6953C23.2668 29.6953 24.0454 29.0891 24.176 28.9258C24.301 28.7695 24.7815 28.2461 24.8948 27.3967L24.7923 14.5529C24.7923 12.8961 23.3204 11.0859 21.6636 11.0859H18.4221Z"
        fill="url(#paint32_radial_8514_64485)"
      />
      <path
        d="M18.4221 11.0859C18.3746 11.3522 18.2363 12.0933 18.2363 12.3732C18.2363 14.2977 19.4097 15.9481 21.0801 16.648V19.4895C21.0801 19.6971 21.1608 19.8966 21.3051 20.0457L21.7236 20.4784C21.8591 20.6184 21.9316 20.8074 21.9247 21.002C21.9191 21.1592 21.8619 21.3101 21.762 21.4316L21.5623 21.6742C21.4627 21.7953 21.4082 21.9473 21.4082 22.1041C21.4082 22.2581 21.4608 22.4074 21.5571 22.5275L21.7524 22.7709C21.8583 22.9029 21.916 23.067 21.916 23.2363C21.916 23.4432 21.8298 23.6407 21.6782 23.7814L21.336 24.0989C21.1728 24.2503 21.0801 24.4628 21.0801 24.6854V26.217C21.0801 27.2094 22.0274 29.6953 23.0198 29.6953C23.2668 29.6953 24.0454 29.0891 24.176 28.9258C24.301 28.7695 24.7815 28.2461 24.8948 27.3967L24.7923 14.5529C24.7923 12.8961 23.3204 11.0859 21.6636 11.0859H18.4221Z"
        fill="url(#paint33_radial_8514_64485)"
      />
      <path
        d="M18.4221 11.0859C18.3746 11.3522 18.2363 12.0933 18.2363 12.3732C18.2363 14.2977 19.4097 15.9481 21.0801 16.648V19.4895C21.0801 19.6971 21.1608 19.8966 21.3051 20.0457L21.7236 20.4784C21.8591 20.6184 21.9316 20.8074 21.9247 21.002C21.9191 21.1592 21.8619 21.3101 21.762 21.4316L21.5623 21.6742C21.4627 21.7953 21.4082 21.9473 21.4082 22.1041C21.4082 22.2581 21.4608 22.4074 21.5571 22.5275L21.7524 22.7709C21.8583 22.9029 21.916 23.067 21.916 23.2363C21.916 23.4432 21.8298 23.6407 21.6782 23.7814L21.336 24.0989C21.1728 24.2503 21.0801 24.4628 21.0801 24.6854V26.217C21.0801 27.2094 22.0274 29.6953 23.0198 29.6953C23.2668 29.6953 24.0454 29.0891 24.176 28.9258C24.301 28.7695 24.7815 28.2461 24.8948 27.3967L24.7923 14.5529C24.7923 12.8961 23.3204 11.0859 21.6636 11.0859H18.4221Z"
        fill="url(#paint34_radial_8514_64485)"
        fill-opacity="0.62"
      />
      <path
        d="M18.4221 11.0859C18.3746 11.3522 18.2363 12.0933 18.2363 12.3732C18.2363 14.2977 19.4097 15.9481 21.0801 16.648V19.4895C21.0801 19.6971 21.1608 19.8966 21.3051 20.0457L21.7236 20.4784C21.8591 20.6184 21.9316 20.8074 21.9247 21.002C21.9191 21.1592 21.8619 21.3101 21.762 21.4316L21.5623 21.6742C21.4627 21.7953 21.4082 21.9473 21.4082 22.1041C21.4082 22.2581 21.4608 22.4074 21.5571 22.5275L21.7524 22.7709C21.8583 22.9029 21.916 23.067 21.916 23.2363C21.916 23.4432 21.8298 23.6407 21.6782 23.7814L21.336 24.0989C21.1728 24.2503 21.0801 24.4628 21.0801 24.6854V26.217C21.0801 27.2094 22.0274 29.6953 23.0198 29.6953C23.2668 29.6953 24.0454 29.0891 24.176 28.9258C24.301 28.7695 24.7815 28.2461 24.8948 27.3967L24.7923 14.5529C24.7923 12.8961 23.3204 11.0859 21.6636 11.0859H18.4221Z"
        fill="url(#paint35_radial_8514_64485)"
      />
      <path
        d="M18.4221 11.0859C18.3746 11.3522 18.2363 12.0933 18.2363 12.3732C18.2363 14.2977 19.4097 15.9481 21.0801 16.648V19.4895C21.0801 19.6971 21.1608 19.8966 21.3051 20.0457L21.7236 20.4784C21.8591 20.6184 21.9316 20.8074 21.9247 21.002C21.9191 21.1592 21.8619 21.3101 21.762 21.4316L21.5623 21.6742C21.4627 21.7953 21.4082 21.9473 21.4082 22.1041C21.4082 22.2581 21.4608 22.4074 21.5571 22.5275L21.7524 22.7709C21.8583 22.9029 21.916 23.067 21.916 23.2363C21.916 23.4432 21.8298 23.6407 21.6782 23.7814L21.336 24.0989C21.1728 24.2503 21.0801 24.4628 21.0801 24.6854V26.217C21.0801 27.2094 22.0274 29.6953 23.0198 29.6953C23.2668 29.6953 24.0454 29.0891 24.176 28.9258C24.301 28.7695 24.7815 28.2461 24.8948 27.3967L24.7923 14.5529C24.7923 12.8961 23.3204 11.0859 21.6636 11.0859H18.4221Z"
        fill="url(#paint36_radial_8514_64485)"
      />
      <path
        d="M18.4221 11.0859C18.3746 11.3522 18.2363 12.0933 18.2363 12.3732C18.2363 14.2977 19.4097 15.9481 21.0801 16.648V19.4895C21.0801 19.6971 21.1608 19.8966 21.3051 20.0457L21.7236 20.4784C21.8591 20.6184 21.9316 20.8074 21.9247 21.002C21.9191 21.1592 21.8619 21.3101 21.762 21.4316L21.5623 21.6742C21.4627 21.7953 21.4082 21.9473 21.4082 22.1041C21.4082 22.2581 21.4608 22.4074 21.5571 22.5275L21.7524 22.7709C21.8583 22.9029 21.916 23.067 21.916 23.2363C21.916 23.4432 21.8298 23.6407 21.6782 23.7814L21.336 24.0989C21.1728 24.2503 21.0801 24.4628 21.0801 24.6854V26.217C21.0801 27.2094 22.0274 29.6953 23.0198 29.6953C23.2668 29.6953 24.0454 29.0891 24.176 28.9258C24.301 28.7695 24.7815 28.2461 24.8948 27.3967L24.7923 14.5529C24.7923 12.8961 23.3204 11.0859 21.6636 11.0859H18.4221Z"
        fill="url(#paint37_radial_8514_64485)"
      />
      <path
        d="M18.4221 11.0859C18.3746 11.3522 18.2363 12.0933 18.2363 12.3732C18.2363 14.2977 19.4097 15.9481 21.0801 16.648V19.4895C21.0801 19.6971 21.1608 19.8966 21.3051 20.0457L21.7236 20.4784C21.8591 20.6184 21.9316 20.8074 21.9247 21.002C21.9191 21.1592 21.8619 21.3101 21.762 21.4316L21.5623 21.6742C21.4627 21.7953 21.4082 21.9473 21.4082 22.1041C21.4082 22.2581 21.4608 22.4074 21.5571 22.5275L21.7524 22.7709C21.8583 22.9029 21.916 23.067 21.916 23.2363C21.916 23.4432 21.8298 23.6407 21.6782 23.7814L21.336 24.0989C21.1728 24.2503 21.0801 24.4628 21.0801 24.6854V26.217C21.0801 27.2094 22.0274 29.6953 23.0198 29.6953C23.2668 29.6953 24.0454 29.0891 24.176 28.9258C24.301 28.7695 24.7815 28.2461 24.8948 27.3967L24.7923 14.5529C24.7923 12.8961 23.3204 11.0859 21.6636 11.0859H18.4221Z"
        fill="url(#paint38_radial_8514_64485)"
        fill-opacity="0.8"
      />
      <path
        d="M18.4221 11.0859C18.3746 11.3522 18.2363 12.0933 18.2363 12.3732C18.2363 14.2977 19.4097 15.9481 21.0801 16.648V19.4895C21.0801 19.6971 21.1608 19.8966 21.3051 20.0457L21.7236 20.4784C21.8591 20.6184 21.9316 20.8074 21.9247 21.002C21.9191 21.1592 21.8619 21.3101 21.762 21.4316L21.5623 21.6742C21.4627 21.7953 21.4082 21.9473 21.4082 22.1041C21.4082 22.2581 21.4608 22.4074 21.5571 22.5275L21.7524 22.7709C21.8583 22.9029 21.916 23.067 21.916 23.2363C21.916 23.4432 21.8298 23.6407 21.6782 23.7814L21.336 24.0989C21.1728 24.2503 21.0801 24.4628 21.0801 24.6854V26.217C21.0801 27.2094 22.0274 29.6953 23.0198 29.6953C23.2668 29.6953 24.0454 29.0891 24.176 28.9258C24.301 28.7695 24.7815 28.2461 24.8948 27.3967L24.7923 14.5529C24.7923 12.8961 23.3204 11.0859 21.6636 11.0859H18.4221Z"
        fill="url(#paint39_radial_8514_64485)"
        fill-opacity="0.8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="#CDC1DE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint40_linear_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint41_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint42_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint43_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint44_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint45_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint46_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint47_radial_8514_64485)"
        fill-opacity="0.6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint48_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint49_radial_8514_64485)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint50_radial_8514_64485)"
        fill-opacity="0.69"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9414 16.2994C28.6035 15.5958 29.7695 13.9497 29.7695 12.0312C29.7695 9.47262 27.6954 7.39844 25.1367 7.39844C22.5781 7.39844 20.5039 9.47262 20.5039 12.0312C20.5039 13.9557 21.6773 15.6061 23.3477 16.306V19.1475C23.3477 19.3551 23.4283 19.5546 23.5727 19.7038L23.9912 20.1364C24.1266 20.2764 24.1992 20.4654 24.1923 20.66C24.1866 20.8172 24.1295 20.9681 24.0295 21.0896L23.8299 21.3322C23.7303 21.4533 23.6758 21.6053 23.6758 21.7621C23.6758 21.9161 23.7283 22.0655 23.8247 22.1855L24.02 22.4289C24.1259 22.5609 24.1836 22.725 24.1836 22.8943C24.1836 23.1012 24.0974 23.2987 23.9457 23.4394L23.6036 23.7569C23.4404 23.9083 23.3477 24.1208 23.3477 24.3434V25.875C23.3477 26.8674 24.1522 27.6719 25.1445 27.6719C26.1369 27.6719 26.9414 26.8674 26.9414 25.875V16.2994ZM26.1758 9.63281C26.1758 10.2067 25.7106 10.6719 25.1367 10.6719C24.5629 10.6719 24.0977 10.2067 24.0977 9.63281C24.0977 9.05895 24.5629 8.59375 25.1367 8.59375C25.7106 8.59375 26.1758 9.05895 26.1758 9.63281Z"
        fill="url(#paint51_radial_8514_64485)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_8514_64485"
        x1="6.57689"
        y1="8.8125"
        x2="9.73332"
        y2="8.8125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8F8E93" />
        <stop
          offset="1"
          stop-color="#8F8E93"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8514_64485"
        x1="10.1948"
        y1="1.97886"
        x2="11.8358"
        y2="3.52344"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8F8E93" />
        <stop
          offset="1"
          stop-color="#8F8E93"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8514_64485"
        x1="14.9125"
        y1="1.87631"
        x2="15.1176"
        y2="3.52344"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8F8E93" />
        <stop
          offset="1"
          stop-color="#8F8E93"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint3_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.2927 9.70361) rotate(82.9768) scale(4.4312)"
      >
        <stop
          offset="0.598958"
          stop-color="#8F8E93"
        />
        <stop
          offset="1"
          stop-color="#8F8E93"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint4_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.9375 7.61719) rotate(-90) scale(4.84375 5.28858)"
      >
        <stop
          offset="0.530612"
          stop-color="#AB83C0"
        />
        <stop
          offset="1"
          stop-color="#CBBBDC"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint5_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.19211 9.18359) rotate(180) scale(1.42417 4.99122)"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint6_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0.846967 -0.61204 2.39712 2.96832 18.1868 5.34501)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint7_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0.591461 -0.786674 2.02098 1.35965 16.9874 4.29676)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint8_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0.456971 -0.855719 2.19836 1.05049 15.3833 3.59102)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint9_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0.90288 -0.21428 0.550491 2.07555 19.0338 7.54864)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EDECF3" />
        <stop
          offset="0.677083"
          stop-color="#EDECF3"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint10_linear_8514_64485"
        x1="8.125"
        y1="14.1484"
        x2="15.0625"
        y2="29.9297"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC74E" />
        <stop
          offset="1"
          stop-color="#F7864E"
        />
      </linearGradient>
      <radialGradient
        id="paint11_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.375 29.9297) rotate(-132.274) scale(3.25195 7.57598)"
      >
        <stop stop-color="#FF8650" />
        <stop
          offset="1"
          stop-color="#FF8650"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint12_linear_8514_64485"
        x1="13.9688"
        y1="10.7734"
        x2="13.9687"
        y2="12.2734"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3D04E" />
        <stop
          offset="1"
          stop-color="#F3D04E"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint13_linear_8514_64485"
        x1="13.9688"
        y1="11.0859"
        x2="13.9687"
        y2="11.9817"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD744" />
        <stop
          offset="1"
          stop-color="#FFD744"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_8514_64485"
        x1="4.38545"
        y1="11.0859"
        x2="5.71651"
        y2="12.5151"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD744" />
        <stop
          offset="1"
          stop-color="#FFD744"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint15_linear_8514_64485"
        x1="24.3316"
        y1="11.0859"
        x2="23.2762"
        y2="12.4084"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD744" />
        <stop
          offset="1"
          stop-color="#FFD744"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint16_linear_8514_64485"
        x1="3"
        y1="19.962"
        x2="4.46409"
        y2="19.962"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BA7A35" />
        <stop
          offset="1"
          stop-color="#BA7A35"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_8514_64485"
        x1="3.51889"
        y1="11.0859"
        x2="5.03121"
        y2="12.1168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BA7A35" />
        <stop
          offset="1"
          stop-color="#BA7A35"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_8514_64485"
        x1="3"
        y1="29.225"
        x2="4.31678"
        y2="27.7035"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BA7A35" />
        <stop
          offset="1"
          stop-color="#BA7A35"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint19_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.625 11.0859) rotate(126.254) scale(2.32513 5.25171)"
      >
        <stop stop-color="#FFF760" />
        <stop
          offset="1"
          stop-color="#FFF760"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint20_linear_8514_64485"
        x1="13.9687"
        y1="30.3025"
        x2="13.9687"
        y2="28.5066"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E55D6C" />
        <stop
          offset="1"
          stop-color="#E55D6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint21_linear_8514_64485"
        x1="3"
        y1="29.9297"
        x2="5.00219"
        y2="28.3795"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.260417"
          stop-color="#E55E5D"
        />
        <stop
          offset="1"
          stop-color="#E55D6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint22_linear_8514_64485"
        x1="2.41231"
        y1="20.1908"
        x2="3.77621"
        y2="20.1908"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E55E5D" />
        <stop
          offset="1"
          stop-color="#E55D6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint23_linear_8514_64485"
        x1="26.285"
        y1="20.1908"
        x2="24.1991"
        y2="20.1908"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E55D72" />
        <stop
          offset="1"
          stop-color="#E55D6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint24_linear_8514_64485"
        x1="25.1108"
        y1="20.5078"
        x2="23.3967"
        y2="20.5078"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.291667"
          stop-color="#FFC55D"
        />
        <stop
          offset="1"
          stop-color="#FFC55D"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint25_linear_8514_64485"
        x1="24.9375"
        y1="29.3801"
        x2="23.601"
        y2="28.131"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFB95D" />
        <stop
          offset="1"
          stop-color="#FFC55D"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint26_linear_8514_64485"
        x1="24.5309"
        y1="12.1927"
        x2="23.4527"
        y2="12.897"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFB95D" />
        <stop
          offset="1"
          stop-color="#FFC55D"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint27_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.2828 18.3304) rotate(95.6522) scale(3.3278 3.09996)"
      >
        <stop
          offset="0.765625"
          stop-color="#D98A40"
        />
        <stop
          offset="1"
          stop-color="#D98A40"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint28_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.6081 22.3857) rotate(-87.6141) scale(3.09125 1.61082)"
      >
        <stop
          offset="0.765625"
          stop-color="#D98A40"
        />
        <stop
          offset="1"
          stop-color="#D98A40"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint29_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.0263 17.8193) rotate(43.1524) scale(2.84574)"
      >
        <stop
          offset="0.677083"
          stop-color="#FFCD63"
        />
        <stop
          offset="1"
          stop-color="#FFCD63"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint30_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.213 22.0499) rotate(-90.507) scale(3.58138 1.56807)"
      >
        <stop stop-color="#FFCD63" />
        <stop
          offset="0.0260417"
          stop-color="#FFCD63"
        />
        <stop
          offset="1"
          stop-color="#FFCD63"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint31_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.3477 18.6485) rotate(34.0609) scale(5.69121 7.82719)"
      >
        <stop
          offset="0.21669"
          stop-color="#564F80"
        />
        <stop
          offset="1"
          stop-color="#473154"
        />
      </radialGradient>
      <radialGradient
        id="paint32_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.5983 12.4706) rotate(71.5651) scale(4.81356 3.76901)"
      >
        <stop
          offset="0.104167"
          stop-color="#763616"
        />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint33_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.8169 17.1881) rotate(-149.758) scale(3.13819 2.20703)"
      >
        <stop
          stop-color="#763C16"
          stop-opacity="0.26"
        />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint34_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.7956 16.4084) rotate(87.5239) scale(5.96789 2.4499)"
      >
        <stop stop-color="#763C16" />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint35_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(26.2083 20.171) rotate(-118.185) scale(4.70134 2.90008)"
      >
        <stop stop-color="#763C16" />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint36_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.8063 24.3684) rotate(-104.886) scale(5.79546 3.575)"
      >
        <stop
          offset="0.119792"
          stop-color="#763C16"
        />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint37_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.4163 16.9595) rotate(121.293) scale(2.11569 1.30509)"
      >
        <stop
          offset="0.864583"
          stop-color="#763C16"
        />
        <stop
          offset="1"
          stop-color="#763C16"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint38_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.082 24.6488) rotate(88.2706) scale(3.26112 2.41138)"
      >
        <stop stop-color="#BC553E" />
        <stop
          offset="1"
          stop-color="#BC553E"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint39_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.3202 26.1404) rotate(37.2348) scale(2.16029 2.08273)"
      >
        <stop stop-color="#BC553E" />
        <stop
          offset="1"
          stop-color="#BC553E"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint40_linear_8514_64485"
        x1="23.301"
        y1="21.5647"
        x2="26.1659"
        y2="21.5647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A390B1" />
        <stop
          offset="0.300971"
          stop-color="#A390B1"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint41_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.2295 20.6432) scale(2.03352)"
      >
        <stop
          offset="0.295337"
          stop-color="#A390B1"
        />
        <stop
          offset="0.755388"
          stop-color="#A390B1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint42_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.2656 22.9063) rotate(0.84875) scale(2.10961)"
      >
        <stop
          offset="0.295337"
          stop-color="#A390B1"
        />
        <stop
          offset="0.755388"
          stop-color="#A390B1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint43_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.1367 11.9688) rotate(90) scale(4.8605)"
      >
        <stop
          offset="0.847888"
          stop-color="#CDC1DE"
        />
        <stop
          offset="0.963852"
          stop-color="#A390B1"
        />
        <stop
          offset="1"
          stop-color="#A390B1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint44_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.4687 14.0938) rotate(90) scale(7.5 4.53125)"
      >
        <stop
          offset="0.820833"
          stop-color="#CDC1DE"
        />
        <stop
          offset="1"
          stop-color="#CDC1DE"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint45_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.5 11.6562) rotate(95.3558) scale(3.89199)"
      >
        <stop
          offset="0.727261"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.906268"
          stop-color="#FFFFFF"
          stop-opacity="0.3"
        />
        <stop
          offset="1"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint46_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.1367 12.3594) rotate(93.2721) scale(4.03783 4.33835)"
      >
        <stop
          offset="0.820833"
          stop-color="#CDC1DE"
        />
        <stop
          offset="1"
          stop-color="#CDC1DE"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint47_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.5313 27.1563) rotate(-93.2987) scale(10.8617 1.56351)"
      >
        <stop stop-color="#FFFFFF" />
        <stop
          offset="1"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint48_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.1367 15.2812) rotate(90) scale(12.875 6.69922)"
      >
        <stop
          offset="0.912621"
          stop-color="#BA85E6"
          stop-opacity="0"
        />
        <stop
          offset="0.973301"
          stop-color="#BA85E6"
        />
      </radialGradient>
      <radialGradient
        id="paint49_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.7844 9.54599) rotate(-120.292) scale(1.28408 1.06804)"
      >
        <stop
          offset="0.328125"
          stop-color="#AF87C8"
        />
        <stop
          offset="1"
          stop-color="#AF87C8"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint50_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.5572 10.2801) rotate(-135) scale(1.69251)"
      >
        <stop stop-color="#96919B" />
        <stop
          offset="0.770833"
          stop-color="#96919B"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint51_radial_8514_64485"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.786 10.0813) rotate(-135) scale(1.22054)"
      >
        <stop
          offset="0.166667"
          stop-color="#E5E2ED"
        />
        <stop
          offset="1"
          stop-color="#E5E2ED"
          stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_8514_64485">
        <rect
          width="32"
          height="32"
          fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
